import { useLocation } from 'react-router-dom';

export const useHashValue = () => {
    const { hash } = useLocation();
    const hashKey = hash.replace('#', '');
    return hashKey.length === 0 ? undefined : hashKey;
};
